<div class="dl-page">
  <div class="dl-card">

    <!-- Status visual -->
    <div class="status-zone"
         [class.is-loading]="status === 'loading'"
         [class.is-success]="status === 'success'"
         [class.is-error]="status === 'error'">
      <div class="status-ring"></div>
      <div class="status-icon">

        <ng-container *ngIf="status === 'loading'">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
        </ng-container>

        <ng-container *ngIf="status === 'success'">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </ng-container>

        <ng-container *ngIf="status === 'error'">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </ng-container>

      </div>
    </div>

    <!-- Content -->
    <div class="dl-content">

      <ng-container *ngIf="status === 'loading'">
        <h1 class="dl-title">{{ "BULK_DOWNLOAD_TITLE" | translate }}</h1>
        <p class="dl-desc">{{ "BULK_DOWNLOAD_PREPARING" | translate }}</p>
      </ng-container>

      <ng-container *ngIf="status === 'success'">
        <h1 class="dl-title">{{ "BULK_DOWNLOAD_READY" | translate }}</h1>
        <p class="dl-desc">{{ "BULK_DOWNLOAD_HINT" | translate }}</p>
        <div class="dl-actions">
          <button class="btn-primary" (click)="download()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            {{ "BULK_DOWNLOAD_BTN" | translate }}
          </button>
          <button class="btn-ghost" (click)="goToDashboard()">
            {{ "DASHBOARD" | translate }}
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="status === 'error'">
        <h1 class="dl-title">{{ "BULK_DOWNLOAD_FAILED" | translate }}</h1>
        <p class="dl-desc dl-desc--error">{{ errorMessage }}</p>
        <div class="dl-actions">
          <button class="btn-ghost" (click)="goToDashboard()">
            {{ "DASHBOARD" | translate }}
          </button>
        </div>
      </ng-container>

    </div>

    <p class="dl-footer-note">{{ "BULK_DOWNLOAD_SUBTITLE" | translate }}</p>

  </div>
</div>
